<template>
    <div id="warranty_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="warrantyHeader" v-if="$route.params.id > 0">Update Warranty</span>
                    <span class="page-title" id="warrantyHeader" v-else>Add Warranty</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackWarrantyList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content warranty-create">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarrantyForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="warranty_type_code">Warranty Type:</label>
                                        <v-select v-model="warranty_type_code" name="warranty_type_code" placeholder="Select Warranty Type."
                                            label="text" :options="warrantyTypeCodeArr">
                                        </v-select>
                                        <div class="field-error">{{warranty_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="starting_point_value">Starting Point Value:</label>
                                        <v-select type="text" class="customer-vselect" v-model="starting_point_value" :options="startingPointArr" label="text"
                                                    id="starting_point_value" placeholder="Enter Starting Point Value" name="starting_point_value">
                                        </v-select>
                                        <div class="field-error">{{starting_point_value_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="period">Warranty Period:</label>
                                        <input type="text" class="form-control" v-model="period" id="period" placeholder="Enter Warranty Period" name="period" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{period_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="period">Period Type:</label>
                                        <v-select class="close-remove" v-model="periodType" name="warranty_period_type"
                                            label="text" :options="periodTypeArr">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="period">Warranty Miles:</label>
                                        <input type="text" class="form-control" v-model="miles" id="miles" placeholder="Enter Warranty Miles" name="miles" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{miles_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="period">Document:</label>
                                        <vue-dropzone
                                                    id="insuranceDocs"
                                                    :options="dropzoneOptions"
                                                    :destroyDropzone=false
                                                    ref="dropzone"
                                                    :headers="dropzoneOptions.headers"
                                                    @vdropzone-files-added="manuallyAddFile"
                                                    @vdropzone-complete="afterComplete"
                                                    @vdropzone-success="storeDocument"
                                                    @vdropzone-removed-file="removedSelectedFile"
                                                    @vdropzone-upload-progress="dropzoneUploadProgress"
                                        >
                                        </vue-dropzone>
                                        <div class="field-error">{{docerrors}}</div>
                                        <div  v-if="dropZonePreviewFiles != null && dropZonePreviewFiles.length > 0">
                                            <label class="control-label" for="period">Attachments:</label>
                                            <div class="policy-attachment">
                                                <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                                    <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                        <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                        <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                        <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                        <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                            {{ uFile['file_name'] }}
                                                        </a>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);" class="">
                                                            <i class="fp-close color-red"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createWarrantyBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateWarranty" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" id="createWarrantyBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateWarranty" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" id="createAndContinueWarrantyBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateWarranty(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="cancelWarrantyBtn" class="btn btn-tertiary" v-on:click.prevent="BackWarrantyList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "WarrantyCreate",
  components: {
        vueDropzone: vue2Dropzone,
        appFooter: () => import('@/components/Footer')
    },
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Warranty | " +process.env.COPYRIGHT_NAME : "Create Warranty | " +process.env.COPYRIGHT_NAME
    }
  },
  mixins:[commonMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    code: "",
    description: "",
    starting_point_value: null,
    effective_date: "",
    period: "",
    periodTypeArr:[{value:"month",text:"Month"},{value:"year",text:"Year"}],
    periodType:{value:"month",text:"Month"},
    miles:"",
    options: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
    },
    warranty_type_code: null,
    warrantyTypeCodeArr: [],

    loading:false,
    code_error_msg: "",
    description_error_msg: "",
    starting_point_value_error_msg: "",
    effective_date_error_msg: "",
    period_error_msg: "",
    miles_error_msg:"",
    warranty_type_error_msg:"",
    velocity_env:process.env.NODE_ENV,


    dropzoneOptions: {
        url: process.env.ROOT_API +"/warranty/store-docs",
        method: 'POST',
        maxFilesize: 3.99, //MB
        maxFiles: 5,
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        acceptedFiles: ".jpg, .jpeg, .png, .doc, .pdf, .docx",
        headers: {
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": '*',
            "Authorization": "Bearer "+localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
        },
        dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
        destroyDropzone:false,
    },
    files:[],
    dropZonePreviewFiles:[],
    docerrors:'',

  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                  if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
                    if (permissions[i].name == 'ev_add_warranty') {
                        self.cantAccessPage = true;
                    }
                  }else{
                    if (permissions[i].name == 'add_warranty') {
                        self.cantAccessPage = true;
                    }
                  }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadWarrantyTypes();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadWarranty();
        }
  },
  methods: {

    BackWarrantyList() {
      var self = this;
      self.$router.push("/warranty/list");
    },

    CreateWarranty(flag) {

        var self = this;
        var error = false;

        self.code = self.code.trim();

        self.code_error_msg = "";
        self.description_error_msg = "";
        self.starting_point_value_error_msg = "";
        self.warranty_type_error_msg = "";
        self.period_error_msg = "";

        if (!self.code || self.code == null || self.code == "") {
            self.code_error_msg = "Code is required.";
            error = true;
        }

        if (!self.description || self.description == null || self.description == "") {
            self.description_error_msg = "Description is required.";
            error = true;
        }

        if (self.starting_point_value == null || !self.starting_point_value.value || self.starting_point_value.value == "") {
            self.starting_point_value_error_msg = "Starting point value is required.";
            error = true;
        }

        if (!self.warranty_type_code || self.warranty_type_code == null || self.warranty_type_code == "") {
            self.warranty_type_error_msg = "Warranty type is required.";
            error = true;
        }

        if (!self.period || self.period == null || self.period == "") {
            self.period_error_msg = "Warranty period is required.";
            error = true;
        }

        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createWarrantyBtn").val("Updating ...");
                $("#createWarrantyBtn").prop("disabled", true);
                $("#cancelWarrantyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueWarrantyBtn").val("Saving ...");
                    $("#createWarrantyBtn").prop("disabled", true);
                    $("#createAndContinueWarrantyBtn").prop("disabled", true);
                    $("#cancelWarrantyBtn").prop("disabled",true);

                }else{

                    $("#createWarrantyBtn").val("Saving ...");
                    $("#createWarrantyBtn").prop("disabled", true);
                    $("#createAndContinueWarrantyBtn").prop("disabled", true);
                    $("#cancelWarrantyBtn").prop("disabled",true);
                }

            }

            var fields = $('#WarrantyForm').serializeArray();

            fields.push({name: "starting_point_value", value: self.starting_point_value.value});
            fields.push({name: "warranty_type_id", value: self.warranty_type_code.value});
            fields.push({name: "period_type", value: self.periodType.value});
            fields.push({name: "id", value: segments[3]});

            if ( self.files.length > 0 ) {
                fields.push({name: "doc_path", value: JSON.stringify(self.files)});
            } else {
                fields.push({name: "doc_path", value: null});
            }

            $.ajax({
                url: process.env.ROOT_API + "/warranty/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createWarrantyBtn").val("Update");
                        $("#createWarrantyBtn").prop("disabled", false);
                        $("#cancelWarrantyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueWarrantyBtn").val("Save and Continue");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }else{

                            $("#createWarrantyBtn").val("Save");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#WarrantyForm").trigger("reset");
                            self.code = "";
                            self.description = "";
                            self.starting_point_value = null;
                            self.effective_date = "";
                            self.period = "";
                            self.warranty_type_code = null;
                            // self.warrantyTypeCodeArr = "";

                        }else{
                            self.$router.push("/warranty/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createWarrantyBtn").val("Update");
                        $("#createWarrantyBtn").prop("disabled", false);
                        $("#cancelWarrantyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");

                            $("#createAndContinueWarrantyBtn").val("Save and Continue");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }else{

                            $("#createWarrantyBtn").val("Save");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        }
    },

    loadWarranty() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/warranty/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.code = data.content.code;
                    self.description = data.content.description;

                    self.miles = data.content.miles;
                    self.periodType = {value:data.content.period_type,text:self.ucString(data.content.period_type)};

                    //display dropdown value selected when array is static
                    for ( var i=0; i<self.startingPointArr.length; i++ ) {

                        if ( self.startingPointArr[i].value == data.content.starting_point_value ) {
                            self.starting_point_value = {value:self.startingPointArr[i].value,text:self.startingPointArr[i].text};
                            break;
                        }
                    }
                    if(data.content.period == 0){
                        self.period = "";
                    } else{
                        self.period = data.content.period;
                    }

                    if(data.content.warranty_type_id == null) {
                        self.warranty_type_code = null;
                    }else{
                        self.warranty_type_code = {value:data.content.warranty_type_id,text:data.content.wtName + " (" + data.content.wtValue +")"};
                    }

                    self.dropZonePreviewFiles = data.content.doc_path;
                    self.loadFilesPreview();

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    loadWarrantyTypes() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/warrantytype/search",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.warrantyTypeCodeArr = data.content.warrantytypes;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                if (jqXHR.status == 0) {
                    self.registerError = "Remote server cannot be reached";
                }
            }
        });
    },
    afterComplete(file,response){
        var self = this;
    },
    storeDocument(file,response){

        var self = this;
        $("#createWarrantyBtn").attr("disabled", false);

        var uploadResponse = response;
        //push doc path in files array
        var uploadFile = 1;

        if (self.files.length == 5) {
            self.docerrors = "Maximum 5 files are allowed.";
            uploadFile = 0;
        }

        if (uploadFile == 1) {
            //push doc path in files array
            self.files.push(uploadResponse.content);
        }

    },
    dropzoneUploadProgress(file, totalBytes, totalBytesSent){
        $("#createWarrantyBtn").attr("disabled", true);
    },
    removeAllFiles() {
        var self = this;
        self.$refs.dropzone.removeAllFiles();
    },
    removedSelectedFile(file, xhr, error) {
        var self = this;

        var orderId = "";
        var fileName = JSON.parse(file.xhr.response).content;

        var fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1],orderId,"temp");

        for(var i = 0;i<self.files.length;i++){
            if ( self.files[i].includes(fileName)) {
                self.files.splice(i,1);
            }
        }

    },
    removeServerFile(fileName,key) {

        var self = this;
        var orderId = "";
        var path = window.location.pathname;
        var segments = path.split("/");
        if ( segments[3] != undefined ) {
            orderId = segments[3];
        }

        if (confirm('Are you sure that you want to remove file? ')) {

            self.removeFileFromServer(fileName,orderId,"server");
            self.dropZonePreviewFiles.splice(key,1);

            //remove file from files array
            for ( var i = 0;i<self.files.length;i++ ) {
                if ( self.files[i].includes(fileName)) {
                    self.files.splice(i,1);
                }
            }
        }

    },
    removeFileFromServer(file, orderId,flag){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/warranty/remove-doc",
            type: "POST",
            data: {
                filePath : file,
                id: orderId,
                flag:flag
            },
            headers: {
                "Accept": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": "Bearer " + localStorage.getItem("tkn"),
                "Access-Control-Allow-Headers":
                    "Origin, Content-Type, Authorization,X-Requested-With",
                "Cache-Control": "no-cache"
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'remove-warranty-doc');
            }
        });

    },
    manuallyAddFile(file) {
        var self = this;
        if (self.files.length == 5) {
            self.docerrors = "Maximum 5 files are allowed.";
            return;
        }
    },
    getFilePathFromUrl(value) {

        var path = "";
        var src = value.split('/');
        var file_name = src[src.length - 1];
        var orgPath = src[src.length - 2];
        path = orgPath + "/" + file_name;
        return path;

    },
    //load files in drop zone
    loadFilesPreview:function() {
        var self = this;
        if ( self.dropZonePreviewFiles.length > 0 ) {
            for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {
                var file = { size: self.dropZonePreviewFiles[i].size, name: self.dropZonePreviewFiles[i].file_name, type: self.dropZonePreviewFiles[i].file_type};
                var url = self.dropZonePreviewFiles[i].url;
                //get file path from url
                self.files.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
            }
        }
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/WarrantyCreate.vue